import { styled } from "@mui/material/styles";
import { palette, shadows, typography } from "src/config/theme";
import { Avatar, Typography, alpha, Box } from "@mui/material";
import NotificationsActiveOutlinedIcon from '@mui/icons-material/NotificationsActiveOutlined';
import ButtonComponent from "src/components/shared/Button";
import theme from 'src/config/theme';

export const Texts = styled(Typography)({
    color: palette.gery.black,
    ...theme.typography.smallRegular,
    [theme.breakpoints.down('md')]: {
        ...theme.mobileTypography.smallRegular,
    },
});


export const MainComponent = styled(Box)(({ isExpanded, theme }) => ({
    backgroundColor: theme.palette.gery.white,
    // height: isExpanded ? '596px' : '496px',
    padding: '24px 20px 28px 20px',
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
    transition: 'height 0.3s ease-in-out'
}));

export const Component1 = styled(Box)({
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    // width: '430px',
    height: '76px',
});

export const Component2 = styled(Box)({
    height: '76px',
    display: 'flex',
    gap: '22px',
    [theme.breakpoints.down('md')]: {
        gap: '14px',
        height: '65px'
    },
});
export const InnerComponent = styled(Box)({
    display: 'flex',
    gap: '4px',
    flexDirection: 'column',
    height: '76px',
    flex: 1,
    [theme.breakpoints.down('md')]: {
        height: '76px',
        width: '100%',

    },
})
export const Component3 = styled(Box)({
    height: '76px',
    display: 'flex',
    gap: '22px',
});
export const Component4 = styled(Box)({
    width: 'auto',
    // height: '144px',
    display: 'flex',
    gap: '4px',
    flexDirection: 'column'
});

export const HiddenComponent = styled(Box)({
    height: '76px',
    display: 'flex',
    gap: '22px',
    [theme.breakpoints.down('md')]: {
        gap: '14px',
        height: '65px',
    },
});

export const FooterPart = styled(Box)({
    height: "100px",
    padding: '24px 20px',
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: '16px',
    borderTop: `1px solid ${theme.palette.primary.light1} !important`,
    [theme.breakpoints.down('md')]: {
        height: '80px',
        padding: '20px 16px'
    }
})


export const HeaderPart = styled(Box)({
    backgroundColor: theme.palette.primary.light3,
    color: theme.palette.gery.black,
    ...theme.typography.h3,
    borderBottom: `1px solid ${theme.palette.primary.light1} !important`,
    padding: '20px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: '64px',
    [theme.breakpoints.down('md')]: {
        ...theme.mobileTypography.h4,
        height: '59px',
        padding: '20px 16px'
    },
})
export const SaveButton = styled(ButtonComponent)({
    width: '104px',
    height: '52px',
    borderRadius: '12px',
    padding: '10px 18px',
    backgroundColor: theme.palette.primary.main,
    boxShadow: shadows[1],
    border: `1px solid ${alpha(palette.gery.black, 0.14)}`,
    color: theme.palette.gery.white,
    position: 'relative',
    overflow: 'hidden',
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    '&::after': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: '-100%',
      width: '50%',
      height: '100%',
      background: 'linear-gradient(to right, rgba(255,255,255,0) 0%, rgba(255,255,255,0.3) 50%, rgba(255,255,255,0) 100%)',
      transform: 'skewX(-25deg)',
      animation: 'shine 4s cubic-bezier(0.4, 0, 0.2, 1) infinite',
    },
    '@keyframes shine': {
      '0%': { left: '-100%' },
      '20%': { left: '200%' },
      '100%': { left: '200%' },
    },
    '&:hover': { 
      backgroundColor: theme.palette.gery.white,
      color: theme.palette.primary.main,
      transform: 'translateY(-2px)'
    },
    [theme.breakpoints.down('md')]: {
        minWidth: '78px',
        height: '40px',
        padding: '10px 12px',
    },
})

export const TabsContainer = styled(Box)({
    // backgroundColor: 'red',
    // height: '68px',
    padding: '0px 0px 0 0px',
    borderBottom: `1px solid ${alpha(palette.gery.black, 0.1)}`,
    boxShadow: shadows[3],
    backgroundColor: palette.gery.white,
    display: 'flex',
    alignItems: 'flex-end'
})
export const TabsData = styled(Box)({
    // backgroundColor: palette.gery.extraLightGray,
    padding: '0px 30px',
    flex: 1,
    minHeight: '400px',
    display: 'flex',
    flexDirection: 'column',
    '&::-webkit-scrollbar': {
        display: 'none',
    },
    scrollbarWidth: 'none',
    msOverflowStyle: 'none',
    [theme.breakpoints.down('md')]: {
        padding: 0,
        minHeight: '300px'
    }
});
export const ProfileContainer = styled(Box)({
    width: '80px',
    height: '144px',
    display: 'flex',
    // flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flexStart',
    gap: '-16px',
    position: 'relative'
})

export const ProfileAvatar = styled(Avatar)({
    width: '80px',
    height: '80px',
    borderRadius: '12px',
    padding: '10px',
    backgroundColor: theme.palette.primary.light3,
    fontSize: '44px',
    color: theme.palette.primary.main,
    [theme.breakpoints.down('md')]: {
        width: '64px',
        height: '64px',
        borderRadius: '12px',
        padding: '10px',
        backgroundColor: palette.primary.light3,
        color: palette.primary.main,
        ...theme.mobileTypography.h1
    }
})

export const ProfileIcon = styled(Avatar)({
    width: '30px',
    height: '30px',
    borderRadius: '50%',
    border: `1.5px solid ${theme.palette.gery.white}  `,
    backgroundColor: theme.palette.primary.light3,
    color: theme.palette.primary.main,
    position: 'absolute',
    bottom: 45,
    cursor: 'pointer',
    [theme.breakpoints.down('md')]: {
        bottom: 55,
    }
})
export const BoxContainer = styled(Box)({
    display: 'flex',
    justifyContent: 'center',
    height: '100px',
})